<template>
  <div class="match-project">
    <el-button type="primary" size="mini" @click="getTableData"
      >匹配查询</el-button
    >
    <div class="table">
      <SimpleTable
        :show-index="false"
        ref="matchProject"
        table-code="matchProject"
        :bottomFrozenRowCount="0"
        :columns="customsColumns.length ? customsColumns : columns"
        :data="tableData"
        @row-select="handleRowSelectLeft"
      />
    </div>
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import { sortRecords, aggregationAve, aggregationAverage } from '@/utils/index'

export default {
  name: 'MatchProject',
  components: { SimpleTable },
  props: {
    getParams: {
      type: Function,
      default: null
    },
    customsColumns: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 页面数据
      loading: false,
      columns: [
        {
          field: 'check',
          title: '',
          width: 50,
          cellType: 'checkbox',
          canEdit: true,
          canModify: true
          // aggregation: aggregationAve
        },
        { field: 'name', title: '单项工程名称', width: 100 },
        { field: 'engineeringClassifyName', title: '工程类型', width: 100 },
        { field: 'regionName', title: '所在地区', width: 100 },
        { field: 'address', title: '详细地址', width: 100 },
        { field: 'constructionScale', title: '建筑规模', width: 100 },
        { field: 'directCost', title: '直接费造价', width: 100 },
        { field: 'totalCost', title: '总造价', width: 100 },
        {
          field: 'directCostIndicator',
          title: '直接造价指标',
          width: 100
          // aggregation: aggregationAverage
        },
        { field: 'startDate', title: '开始时间', width: 100 },
        { field: 'endDate', title: '结束时间', width: 100 },
        { field: 'constructionPeriod', title: '工期', width: 100 }
      ],
      tableData: []
    }
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    async getTableData() {
      const data = this.getParams()

      const getValue = (prop, code, key) => {
        const obj = data[prop].find(e => e.code === code)
        return key ? obj?.[key] : obj
      }

      const res = await this.$service.post('/history-data-budget/match/list', {
        address: getValue('tableDataBaseTop', 'xxdz', 'desc'),
        engineeringClassifyIdList: getValue('tableDataBaseTop', 'gclx', 'desc')
          ? getValue('tableDataBaseTop', 'gclx', 'value')?.map(e => e.id)
          : [],
        engineeringFeatureList: data.tableDataProjectTop
          .map(e => ({
            name: e.name,
            value: e.desc
          }))
          .filter(e => e.value),
        engineeringParamList: data.tableDataProjectBottom
          .map(e => ({
            maxValue: e.top,
            minValue: e.bottom,
            name: e.name
          }))
          .filter(e => e.maxValue || e.minValue),
        maxConstructionPeriod: getValue('tableDataBaseBottom', 'gq').top,
        maxConstructionScale: getValue('tableDataBaseBottom', 'jzgm').top,
        maxCostBudget: getValue('tableDataBaseBottom', 'zzj').top,
        maxDirectCostBudget: getValue('tableDataBaseBottom', 'zjzj').top,
        maxEndDate: getValue('tableDataBaseBottom', 'jssj').top,
        maxStartDate: getValue('tableDataBaseBottom', 'kssj').top,
        minConstructionPeriod: getValue('tableDataBaseBottom', 'gq').bottom,
        minConstructionScale: getValue('tableDataBaseBottom', 'jzgm').bottom,
        minCostBudget: getValue('tableDataBaseBottom', 'zzj').bottom,
        minDirectCostBudget: getValue('tableDataBaseBottom', 'zjzj').bottom,
        minEndDate: getValue('tableDataBaseBottom', 'jssj').bottom,
        minStartDate: getValue('tableDataBaseBottom', 'kssj').bottom,
        name: getValue('tableDataBaseTop', 'dxgcmc', 'desc'),
        regionIdList: getValue('tableDataBaseTop', 'szdq', 'desc')
          ? getValue('tableDataBaseTop', 'szdq', 'value')?.map(e => e.id)
          : []
      })
      this.tableData = sortRecords(
        res?.data.map(e => ({ ...e, check: false })) || []
      )
    },

    handleRowSelectLeft(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.$emit('row-select', obj)
    }
  }
}
</script>

<style scoped lang="less">
.match-project {
  height: 338px;
  .table {
    margin-top: 10px;
    height: calc(100% - 38px);
  }
}
</style>
